export var engravingMessageMaxLength = 22;
